import { useRef } from 'react'
import FormButton from './FormButton';

export default function FormInput({ id, type, _value, placeholder, onChangeAction, hasLabel=null, label=null, hasButton=null, buttonText=null, buttonAction=null, required=null, step=null, resetValue=false, editFlag=true, _ref, dir="ltr"}) {
  const inputRef = useRef();
  
  return (
    <div className={hasButton ? "dashboardForm_section_withBtn" :"dashboardForm_section"}>
        {hasLabel && <label htmlFor={id}>{label}</label>}
        {editFlag ? 
          <input
              ref={resetValue ? inputRef : _ref}
              style={{textAlign:"end", fontSize:"16px"}}
              id={id}
              min={type==="number" ? 0 : null}
              value={_value}
              type={type}
              placeholder={
                type==="text"&&_value===""&&!placeholder ? "בחר את ערך הטקסט כאן" : 
                placeholder}
              onChange={onChangeAction}
              required={required}
              step={step}
              dir={dir}
          /> :
          <h3>{
            _value===null||_value===undefined ? "אין מידע להצגה" :
            type==="number"&&_value>0&&label==="מחיר המוצר:" ? `${_value}₪` :
            type==="number"&&_value>0&&label==="אחוז המבצע:" ? `${_value}%` :
            type==="number"&&_value>=100&&label==="אחוז המבצע:" ? `${100}%` :
            _value==="" ? "אין מידע להצגה" : 
            _value
          }</h3>
          }
        {hasButton ? <FormButton disabled={false} type={"button"} text={buttonText} action={()=>{buttonAction(); if(resetValue){inputRef.current.value = ""}}}/> : null}
    </div>
  )
}
